const apiRoleAssignmentConfig = {
  name: 'API Role Assignment',
  endpoint: '/internal_admin/admin_kit/api_role_assignments',
  modelKey: 'rbac_api_role_assignment',

  columns: [
    {
      name: 'oauth_application_name',
      title: 'OAuth Application',
      type: 'link',
    },
    { name: 'api_role_name', title: 'API Role' },
    { name: 'created_by_name', title: 'Created By' },
    { name: 'created_at', title: 'Created' },
  ],

  filters: [
    { name: 'q[api_role_name_cont]', label: 'API Role' },
    { name: 'q[oauth_application_name_cont]', label: 'OAuth Application' },
  ],

  attributes: [
    { name: 'id', label: 'ID' },
    { name: 'oauth_application_name', label: 'OAuth Application' },
    { name: 'api_role_name', label: 'API Role' },
    { name: 'created_by_name', label: 'Created By' },
    { name: 'created_at', label: 'Created At' },
    { name: 'updated_at', label: 'Updated At' },
  ],

  form: {
    fields: [
      {
        name: 'oauth_application_id',
        label: 'OAuth Application',
        type: 'typeahead',
        searchEndpoint:
          '/internal_admin/admin_kit/api_role_assignments/oauth_application_search',
        displayField: 'oauth_application_name',
        required: true,
      },
      {
        name: 'api_role_id',
        label: 'API Role',
        type: 'typeahead',
        searchEndpoint:
          '/internal_admin/admin_kit/api_role_assignments/api_role_search',
        displayField: 'api_role_name',
        required: true,
      },
    ],
  },
};

export default apiRoleAssignmentConfig;
